<template>
<div v-if="hasContent" class="odr-appoint-info">
    <slot/>
</div>
</template>

<script>
import '@/scss/blocks/appoint-info.scss';

export default {
    computed: {
        hasContent () {
            return !!this.$slots.default;
        },
    },

};
</script>
